import { createInstance, type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_UI_LOCALE,
  getTranslationLanguage,
  type SupportedUiLocale,
} from './locales';
import { getBrowserLocale, resolveEffectiveUiLocale } from './localeResolver';
import { resources, TRANSLATION_NAMESPACES } from './resources';

const initializeInstance = (
  instance: I18nInstance,
  locale: SupportedUiLocale,
): I18nInstance => {
  void instance.init({
    resources,
    lng: getTranslationLanguage(locale),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: TRANSLATION_NAMESPACES,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    returnNull: false,
    initAsync: false,
  });

  return instance;
};

/** Creates an isolated instance for tests or future localized subtrees. */
export const createI18nInstance = (
  locale: SupportedUiLocale = DEFAULT_UI_LOCALE,
): I18nInstance => initializeInstance(createInstance(), locale);

export const i18n = createInstance();

i18n.use(initReactI18next);
initializeInstance(i18n, resolveEffectiveUiLocale(null, getBrowserLocale()));